import * as styles from './styles.css';
import { clsx } from 'clsx';
import bgImage from './assets/bg.png';
import bgPhoneImage from './assets/bg-phone.png';
import { Responsive, Spinner, TDeviceType } from '@cian/ui-kit';

export interface INewPromoProps {
  loaded: boolean;
  device: TDeviceType;
  title: string;
  subtitle: string;
  onLoad: () => void;
  imageRef: React.RefObject<HTMLImageElement>;
}

export const NewPromo: React.FC<INewPromoProps> = ({ loaded, device, title, subtitle, onLoad, imageRef }) => {
  return (
    <div className={clsx(styles['container'], styles[device])}>
      <Responsive phone>
        <div className={styles['logo']} />
      </Responsive>
      <div className={styles['subtitle-notice']}>С 20 апреля 2026</div>
      <div className={styles['title']}>{title}</div>
      <div className={styles['subtitle']}>{subtitle}</div>
      <div className={styles['image']}>
        <div className={styles['image-inner']}>
          {!loaded && (
            <div className={styles['spinner-overlay']} aria-hidden>
              <Spinner color="white_100" />
            </div>
          )}
          <img
            ref={imageRef}
            src={device === 'phone' ? bgPhoneImage : bgImage}
            alt=""
            onLoad={onLoad}
            className={clsx(styles['image-img'], loaded && styles['image-img-loaded'])}
          />
        </div>
      </div>
    </div>
  );
};
